import { FC, useEffect, useRef, useState } from "react";
import Form from "@rjsf/core";
// import validator from "@rjsf/validator-ajv8";
import { customizeValidator } from "@rjsf/validator-ajv8";
import { StyledLeftFields } from "./FormBondApp.styled";
import { getUiSchemaIndemnitor } from "./FormBondApp.constants";
import styled from "styled-components";
import { Spinner } from "../Spinner/Spinner";
import { handleValidate } from "../../helpers/utils";
import { CustomValidator } from "@rjsf/utils";
import ShippingService from "../../api/services/ShippingService"

const StyledSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -25px;
`;

let fields: { [key: string]: string } = {};

let filedsArr: string[] = [];

export const FormStart: FC<any> = ({
  data,
  setData,
  submit,
  schema,
  widgets,
  isLoading,
  isSkipBond,
  uiSchema,
  step,
  omitExtraData,
  liveOmit,
  handleUpdateShippingMethods
}) => {
  const formStartRef = useRef<any>(null);
  const [errorsSchema, setErrorsSchema] = useState<any>({});
  const [touchedFields, setTouchedFields] = useState<string[]>([]);
  const lastErrors = useRef<any[] | null>(null);
  const [isFirstTimeSubmited, setIsFirstTimeSubmited] = useState(false);

  const lefts = schema?.required?.filter(
    (field: string) => !data?.[field] && data?.[field] !== false
  )?.length;

  function transformErrors(errors: any) {
    lastErrors.current = errors;
    const isSchemaZipFormatError = (error: any) =>
      error?.property?.includes("zip") && error.name !== "required";

    const filteredErrors = errors.filter(
      (error: any) =>
        filedsArr.includes(error?.property?.replace(".", "")) &&
        !isSchemaZipFormatError(error)
    );
    const deletedDublicatesErrors = (
      isFirstTimeSubmited
        ? errors.filter((error: any) => !isSchemaZipFormatError(error))
        : filteredErrors
    ).reduce((acc: any, item: any) => {
      if (acc?.find((accItem: any) => accItem.property === item.property)) {
        return acc;
      }
      return [...acc, item];
    }, []);

    return deletedDublicatesErrors.map((error: any) => {
      if (error.name === "required") {
        if (error.params?.missingProperty === "agreed_to_terms_and_conditions") {
          error.message = "You must agree to the Terms and Conditions";
        } else {
          error.message = error.message.replace(
            /must have required property '(.*)'$/,
            "'$1' is a required field"
          );
        }
      }

      if (error.name === "pattern" || error.name === "format") {
        error.message = `Invalid ${error?.property.replace(".", "")} number`;
        if (error.property.includes("phone")) {
          error.message = `Please enter a valid phone number`;
        }

        if (error.property.includes("email")) {
          error.message = `Please enter a valid email address`;
        }
      }

      return error;
    });
  }

  useEffect(() => {
    setTimeout(() => {
      formStartRef?.current && formStartRef?.current?.validateForm();
    }, 0);
  }, [filedsArr, formStartRef]);

  const addAllToTouchedFields = () => {
    filedsArr = schema?.required;
    setTouchedFields(schema?.required);
  };

  useEffect(() => {
    const submitButton = document?.getElementsByClassName("submit_button")?.[0];
    submitButton?.addEventListener("click", addAllToTouchedFields);
    return () => {
      return submitButton?.removeEventListener("click", addAllToTouchedFields);
    };
  }, []);

  const customFormats = {
    "phone us": /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/,
    "email address":
      /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
    "social security number":
      /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){9,10}(\s*)?$/
  };

  const validator = customizeValidator({ customFormats });

  const customValidate: CustomValidator<any, any, any> | undefined = (
    formData,
    errors
  ) => {
    if (formData?.mailing_zip && !/^\d{5}$/.test(formData?.mailing_zip)) {
      errors?.mailing_zip?.addError("Please enter a valid 5 digit zip code");
    }
    if (formData?.agreed_to_terms_and_conditions === false) {
      errors?.agreed_to_terms_and_conditions?.addError(
        "You must agree to the Terms and Conditions"
      );
    }
    return errors;
  };

  return (
    <>
      {isLoading && (
        <StyledSpinnerContainer>
          <Spinner />
          <span>Loading...</span>
        </StyledSpinnerContainer>
      )}

      <div style={{ display: isLoading ? "none" : "block" }}>
        <Form
          ref={formStartRef}
          onChange={(e: any, es: any) => {

            setData(e.formData);

            if ('state_code' in e.formData) {

              const recordId = e.formData.record_salesforce_id;
              const shippingStateCode = e.formData.state_code;

              ShippingService.getShippingMethods(recordId, shippingStateCode)
                .then((response) => {
                  handleUpdateShippingMethods(response.data);
                });
            }

            handleValidate(formStartRef, e.formData, schema);
          }}
          onBlur={(id: any, value) => {
            const fieldName = id.split("root_")[1];

            filedsArr = [...filedsArr, fieldName];

            setTouchedFields(values => [...values, fieldName]);
          }}
          formData={data}
          uiSchema={uiSchema || getUiSchemaIndemnitor(false)}
          schema={isSkipBond ? {} : schema}
          onSubmit={() => {
            if (!isFirstTimeSubmited) setIsFirstTimeSubmited(true);
            if (!!lastErrors.current?.length) {
              return;
            }
            addAllToTouchedFields();
            submit();
          }}
          customValidate={customValidate}
          widgets={widgets}
          transformErrors={transformErrors}
          validator={validator}
          showErrorList={false}
          noHtml5Validate={true}
          liveValidate
          omitExtraData={omitExtraData}
          liveOmit={liveOmit}
        />

        {!!lefts && !isSkipBond && (
          <StyledLeftFields>{lefts} required field(s) left</StyledLeftFields>
        )}
      </div>
    </>
  );
};
